import { Col, Grid, Loader, Row } from 'rsuite';
import InstanceInfo from './InstanceInfo';
import Resource from './Resource';
import { InstanceActions } from '@monorepo/shared';
import { InstanceAction, server } from '../../config/const';
import { useState } from 'react';

interface IProps {
  rowData: Record<string, any>;
}

const Instance = ({ rowData }: IProps) => {
  return (
    <Grid fluid className="instance-content">
      <>
        <Row className="show-grid instance-content-row" gutter={0}>
          <Col span={12} className="instance-content-col">
            <div
              className="instance-content-container"
              style={{
                marginRight: '10px'
              }}
            >
              <Resource rowData={rowData} />
            </div>
          </Col>
          <Col span={12} className="instance-content-col">
            <div
              className="instance-content-container"
              style={{
                marginLeft: '10px'
              }}
            >
              <InstanceInfo rowData={rowData} />
            </div>
          </Col>
        </Row>
        <Row>
          <Col span={24} className="instance-content-controller">
            <InstanceActions
              rowData={rowData}
              server={server}
              actionConst={InstanceAction}
            />
          </Col>
        </Row>
      </>
    </Grid>
  );
};

export default Instance;
